var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 485",
    width: 80,
    height: 10,
    fill: "#B88D00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 486",
    x: 80,
    y: 80,
    width: 80,
    height: 10,
    transform: "rotate(-90 80 80)",
    fill: "#B88D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBright);
export default __webpack_public_path__ + "static/media/bright.88c6e163f6c4ddfa91e6482e1e2c6fc7.svg";
export { ForwardRef as ReactComponent };